import React from 'react'
import { useController, useFormContext } from 'react-hook-form'
import { addMonths, addWeeks, isFuture } from 'date-fns'
import { Button, Stack, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import { RegisteredTextField } from '../../../components/fields/TextField'
import { RegisteredDatePicker } from '../../../components/fields/DatePicker'

type CommentsFieldsComponent = React.FC<{
    setIsCustomFormDirty: React.Dispatch<React.SetStateAction<boolean>>
}>

export const CommentsFields: CommentsFieldsComponent = () => {
    const { control, getValues } = useFormContext()
    const { generalMeetingDate, subStartDate } = getValues()

    // Using react-hook-form's useController to manage DatePicker state
    const {
        field: { onChange, value },
    } = useController({
        name: 'statusHideUntil',
        control,
    })

    const gmDate = generalMeetingDate ? new Date(generalMeetingDate) : null
    const subscriptionStartDate = subStartDate ? new Date(subStartDate) : null
    return (
        <Grid spacing={2} direction='row' container>
            <Grid size={6}>
                <RegisteredTextField
                    name='internalComment'
                    sx={{ width: '100%' }}
                    label='Intern Kommentar'
                    multiline
                    minRows={3}
                />
            </Grid>
            <Grid size={6}>
                <RegisteredTextField
                    name='externalComment'
                    sx={{ width: '100%' }}
                    label='Extern Kommentar'
                    multiline
                    minRows={3}
                />
            </Grid>
            <Grid size={12}>
                <Stack
                    direction='row'
                    spacing={2}
                    sx={{
                        alignItems: 'center',
                    }}
                >
                    <Typography variant='body2'>Snooze</Typography>
                    <RegisteredDatePicker validation='' name='statusHideUntil' disablePast sx={{ width: '200px' }} />
                    <Button
                        onClick={() => {
                            if (value) {
                                onChange(addWeeks(value, 1))
                            } else {
                                onChange(addWeeks(new Date(), 1))
                            }
                        }}
                    >
                        +Vecka
                    </Button>
                    <Button
                        onClick={() => {
                            if (value) {
                                onChange(addMonths(value, 1))
                            } else {
                                onChange(addMonths(new Date(), 1))
                            }
                        }}
                    >
                        +Månad
                    </Button>
                    <Button
                        disabled={!gmDate || !isFuture(gmDate)}
                        onClick={() => {
                            onChange(gmDate)
                        }}
                    >
                        Bolagsstämma
                    </Button>
                    <Button
                        disabled={!subscriptionStartDate || !isFuture(subscriptionStartDate)}
                        onClick={() => {
                            onChange(new Date(subscriptionStartDate!))
                        }}
                    >
                        Startdatum
                    </Button>
                </Stack>
            </Grid>
        </Grid>
    )
}
